import { REPORTS } from "../action/type";

const initialState = {
    list: [{}],
};
const report = function (state = initialState, action) {
    switch (action.type) {
        case REPORTS:
            return { ...state, list: action.payload };
        default:
            return state;
    }
}
export default report;